module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAlCAMAAACJZBL9AAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMA8pPe1Emb9UPs+s6qdAsJ6OEW7owfBcO3sKRrYty9n5qBWFMSCD9UAgAAAL1JREFUOMu90NkOgyAQQFFQW2Wp4L527/z/L7YRDIKWlzbe15PMTAalnGArKZIKzXXghnpZz7rCGJ2AzRxvKTChFG8qRC+fQpYbPTPGImpUsVYyjWksBVlppS3nvCu03kGXbO0ds3AKs7VSZForNLdAVyrFz0RVgpVSUon0kxCDhdid/HfNomXYVoKsBlspPy6L9roZPw5O5UKLHDmN+3xShk7E+qRbHRul18Cppz9fFXsVvHrxMcrbAn+J8DeHWmnTUgVLbwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/menu-icon6.png
// module id = +5bw
// module chunks = 1